<template>
  <div class="shopping-cart-detail">
    <div class="shopping-cart-detail__left-detail">
      <div class="shopping-cart-detail__header">
        <h1>Losmotiv</h1>
        <a v-if="!item.isFreeLot" v-bind:href="item.cardDesignerUrl">Bearbeiten</a>
      </div>
      <div class="shopping-cart-detail__image-container">
        <img v-if="!item.isFreeLot" :src="`${item.lotImageUrl}?${Date.now()}`" alt="" @click="changeModal(true)">
        <img  v-else :src="`${item.lotImageUrl}?${Date.now()}`" alt="">
        <span v-if="!item.isFreeLot" class="btn btn--default btn--circle" @click="changeModal(true)">
            <span class="icon icon-search icon-bold transform-flip-x"></span>
        </span>
      </div>
    </div>
    <hr class="shopping-cart-divider">
    <div class="shopping-cart-detail__right-detail">
      <div class="shopping-cart-detail__content">
        <div class="shopping-cart-detail__header">
          <h1>Eigenschaften</h1>
          <a v-if="!item.isFreeLot" v-bind:href="item.lotConfiguratorUrl">Bearbeiten</a>
        </div>
        <div class="shopping-cart-detail__text-container">
          <div v-if="!item.isFreeLot">
            <strong>Losnummer:</strong><span>{{ item.lotNumber }}</span>
          </div>
          <div>
            <strong>Laufzeit:</strong><span>{{ item.lotRuntime }}</span>
          </div>
          <div v-if="!item.isVoucherGift">
            <strong>Mitspielbeginn:</strong><span>{{ formatDate(item.startPlayingDate) }}</span>
          </div>
          <div class="spacer"></div>
          <div v-if="!item.isFreeLot">
            <strong>Losformat:</strong><span>{{ item.lotFormatText }}</span>
          </div>
        </div>
      </div>
      <template v-if="item.lotType == 'PrivateLot' && item.isVoucherGift == false">
        <div class="shopping-cart-detail__content">
          <div class="shopping-cart-detail__header">
            <h1>Losbesitzer</h1>
            <a v-if="!item.isFreeLot" v-bind:href="item.product.toLowerCase() == 'jahreslos'? item.lotConfiguratorUrl: item.cardDesignerUrl">Bearbeiten</a>
          </div>
          <div class="shopping-cart-detail__text-container">
            <div>
              <span>Das Los ist für dich.</span>
            </div>
          </div>
        </div>
      </template>
      <template v-if="item.isVoucherGift">
        <div class="shopping-cart-detail__content">
          <div class="shopping-cart-detail__header">
            <h1>Los zum Aktivieren</h1>
          </div>
          <div class="shopping-cart-detail__text-container">
            <div>
              <span>Den Mitspielbeginn legt der Beschenkte
                ganz einfach und schnell fest, indem er das
                Los aktiviert.</span>
            </div>
          </div>
        </div>
      </template>
      <template v-if="item.lotType == 'GiftLot' && item.isVoucherGift == false && item.lotOwner.firstname">
        <div class="shopping-cart-detail__content">
          <div class="shopping-cart-detail__header">
            <h1>Beschenkter</h1>
            <a v-if="!item.isFreeLot" v-bind:href="item.product.toLowerCase() == 'jahreslos'? item.lotConfiguratorUrl: item.cardDesignerUrl">Bearbeiten</a>
          </div>
          <div class="shopping-cart-detail__text-container">
            <div>
              <span>{{ item.lotOwner.firstname +' '+ item.lotOwner.lastname }}</span>
            </div>
            <div>
              <span>{{ item.lotOwner.street +' '+ item.lotOwner.houseNumber }}</span>
            </div>
            <div>
              <span>{{ item.lotOwner.zipCode +' '+ item.lotOwner.city }}</span>
            </div>
            <div>
              <span>{{ getCountryName(item.lotOwner.country) }}</span>
            </div>
          </div>
        </div>
      </template>
      <template v-if="item.lotType == 'VoucherLot' && item.isVoucherGift && item.lotAddress">
        <div class="shopping-cart-detail__content">
          <div class="shopping-cart-detail__header">
            <h1>Beschenkter</h1>
            <a v-if="!item.isFreeLot" v-bind:href="item.product.toLowerCase() == 'jahreslos' ? item.lotConfiguratorUrl : item.cardDesignerUrl">Bearbeiten</a>
          </div>
          <div class="shopping-cart-detail__text-container">
            <div>
              <span>{{ item.lotAddress.firstname + ' ' + item.lotAddress.lastname }}</span>
            </div>
            <div>
              <span>{{ item.lotAddress.street + ' ' + item.lotAddress.houseNumber }}</span>
            </div>
            <div>
              <span>{{ item.lotAddress.zipCode + ' ' + item.lotAddress.city }}</span>
            </div>
            <div>
              <span>{{ getCountryName(item.lotAddress.country) }}</span>
            </div>
          </div>
        </div>
      </template>

      <template v-if="item.lotFormat == 'HighQualityPrinted'">
        <div class="shopping-cart-detail__content">
          <div class="shopping-cart-detail__header">
            <h1>Los-Versand</h1>
            <a v-if="!item.isFreeLot" v-bind:href="item.lotConfiguratorUrl">Bearbeiten</a>
          </div>
          <div class="shopping-cart-detail__text-container">
            <div>
              <template v-if="item.shippingTarget=='Customer'">
                <strong>Meine Adresse</strong>
              </template>
              <template v-else>
                <strong>Beschenkter</strong>
              </template>
            </div>
            <div>
              <span>Versanddatum</span>
            </div>
            <div>
              <span>{{ formatDate(item.shippingDate) }}</span>
            </div>
            <div>
              <span>Lieferfrist</span>
            </div>
            <div>
              <span>Versanddatum + 1-3 Werktage </span>
            </div>
            <div class="spacer"></div>
            <div>
              <em>Wir übernehmen die Kosten fur den Versand
                innerhalb der EU und der Schweiz</em>
            </div>
          </div>
        </div>
      </template>
      <template v-if="item.winningInformation.length > 0">
        <div class="shopping-cart-detail__content">
          <div class="shopping-cart-detail__header">
            <h1>Gewinnchancen</h1>
            <a v-if="!item.isFreeLot" v-bind:href="item.lotConfiguratorUrl">Bearbeiten</a>
          </div>
          <div class="shopping-cart-detail__text-container">
            <template v-for="(winningInformation, index) in item.winningInformation" :key="index">
              <div class="shopping-cart-detail__winning-container">
                <strong>{{ winningInformation.monthlyDrewCategory }} x {{ winningInformation.category }} {{ getTranslation(winningInformation.paymentInterval) }}</strong>
                <strong>{{ formatCurrency(winningInformation.categoryPrice) }}</strong>
                <div class="shopping-cart-detail__winning-container-options">
                  <template v-if="winningInformation.maxWinningAmount != 0">
                    <span>Chance auf: {{ formatCurrency(winningInformation.maxWinningAmount, false) }} einmalig</span>
                  </template>
                  <template v-if="winningInformation.monthlyMaxWinningAmount != 0">
                    <span>Chance auf: {{ formatCurrency(winningInformation.monthlyMaxWinningAmount, false) }} monatlich</span>
                  </template>
                </div>
                <span>{{ getTranslation(winningInformation.paymentInterval) }}</span>
              </div>
            </template>
            <div class="shopping-cart-detail__svl-container">
              <strong>{{ item.svlInformation }}</strong>
            </div>
            <div v-if="isBlackWeekActive" class="shopping-cart-detail__svl-container shopping-cart-detail__black-week">
              Los kaufen, Gratis-Los sichern und an 10 Ziehungen im April teilnehmen.
            </div>
          </div>
        </div>
      </template>
    </div>
    <ShoppingCartModal :show="showModal" :imageFrontSrc="item.realPreviewImageUrlFront" :imageBackSrc="item.realPreviewImageUrlBack" @update:show="changeModal" />
  </div>
</template>
  
  <script>
import ShoppingCartModal from './ShoppingCartModal.vue';

export default {
  name: 'ShoppingCartDetail',
  props: {
    item: {
      type: Object,
      required: true
    },
  },

  data() {
    return {
      showModal: false,
    };
  },

  computed: {
    isBlackWeekActive() {
      const now = new Date();
      const currentDay = now.getDate();
      const currentMonth = now.getMonth() + 1; // getMonth() returns 0-11
      const currentYear = now.getFullYear();

      // Check if it's March 2026 and the item meets the type conditions
      const isMarch2026 = currentDay >= 2 && currentMonth === 3 && currentYear === 2026 && currentDay <= 15 ;
      const isValidLotType = this.item.product.toLowerCase() === "glücks-los";

      return isMarch2026 && isValidLotType;
    }
  },

  methods: {
    formatDate(date) {
      date = new Date(date);
      let day = date.getDate();
      let month = date.getMonth() + 1; // Months are zero-based in JavaScript
      let year = date.getFullYear();

      // Add leading zeros if day or month is less than 10
      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }

      return day + '.' + month + '.' + year;
    },

    getCountryName(countryCode) {
      switch (countryCode) {
        case 'B':
          return 'Belgien';
        case 'BG':
          return 'Bulgarien';
        case 'D':
          return 'Deutschland';
        case 'DK':
          return 'Dänemark';
        case 'EST':
          return 'Estland';
        case 'FIN':
          return 'Finnland';
        case 'F':
          return 'Frankreich';
        case 'GR':
          return 'Griechenland';
        case 'GB':
          return 'Großbritannien';
        case 'IRL':
          return 'Irland';
        case 'I':
          return 'Italien';
        case 'HR':
          return 'Kroatien';
        case 'LV':
          return 'Lettland';
        case 'LT':
          return 'Litauen';
        case 'L':
          return 'Luxemburg';
        case 'MLT':
          return 'Malta';
        case 'NL':
          return 'Niederlande';
        case 'PL':
          return 'Polen';
        case 'P':
          return 'Portugal (inkl. Madeira und Azoren)';
        case 'R':
          return 'Rumänien';
        case 'S':
          return 'Schweden';
        case 'CH':
          return 'Schweiz';
        case 'SK':
          return 'Slowakei';
        case 'SLO':
          return 'Slowenien';
        case 'E':
          return 'Spanien (inkl. Kanarische Inseln)';
        case 'CZ':
          return 'Tschechische Republik';
        case 'H':
          return 'Ungarn';
        case 'CY':
          return 'Zypern';
        case 'A':
          return 'Österreich';
        default:
          return 'Unknown country code';
      }
    },

    getTranslation(word) {
      if (word == 'monatlich') {
        return 'pro Monat'
      }
      if (word == 'einmalig') {
        return 'einmal'
      }
      return word;
    },

    formatCurrency(amount, miniDecimal = true) {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: miniDecimal ? 2 : 0,
        maximumFractionDigits: miniDecimal ? 2 : 0
      }).format(amount);
    },
    changeModal: function(value) {
      this.showModal = value;
    }
  },
  components: {
    ShoppingCartModal,
  },
}
  </script>
  
<style lang="scss" scoped>
.shopping-cart-detail__black-week {
  font-family: "Aktion Mensch Bold";
}

.shopping-cart-divider {
  display: none;
  height: 1px;
  background-color: #eeeeee;
  border: none;
  position: relative;
  margin: 14px -16px 8px;

  @media (max-width: 767px) {
    display: block;
  }
}

.shopping-cart-detail {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 32px;
  padding-bottom: 34px;

  @media (max-width: 767px) {
    grid-gap: 0px;
    padding-bottom: 24px;
  }

  &__text-container {
    display: grid;
    grid-gap: 11px;
    line-height: 16px;
    font-size: 14px;
    grid-template-columns: 1fr;

    .spacer {
      height: 1px;
    }

    em {
      font-size: 12px;
    }

    div {
      strong {
        font-family: "Aktion Mensch Bold";
        margin-right: 5px;
      }
    }
  }

  &__image-container {
    position: relative;
    cursor: pointer;

    img {
      width: 100%;
    }
  }

  &__winning-container {
    position: relative;
    display: grid;
    padding-left: 24px;
    grid-template-columns: 1fr 75px;
    column-gap: 5px;
    row-gap: 5px;

    strong {
      margin: 0 !important;
    }

    &-options span {
      display: block;
    }
  }
  
  &__svl-container {
    position: relative;
    padding-left: 24px;
    line-height: 21px;
  }

  &__winning-container,
  &__svl-container {
    &:after {
      top:0;
      left: 0;
      content: "\f121";
      font-family: "icons-webfont";
      position: absolute;
      height: 16px;
      width: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      color: green;
    }
  }

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }

  &__header {
    padding: 8px 0 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h1 {
      font-family: "Aktion Mensch Bold";
      color: var(--color-red);
      font-size: 16px;
    }

    a {
      padding: 6px 12px 7px 32px;
      border-radius: 17px;
      border: 1px solid;
      text-decoration: none;
      font-size: 14px;
      line-height: 17px;
      position: relative;

      &:after {
        content: "\f1fa";
        font-family: "icons-webfont";
        position: absolute;
        height: 25px;
        width: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        left: 7px;
        top: 3px;
        font-size: 13px;
      }

      &:hover {
        color: var(--color-red);
      }
    }
  }

  &__right-detail {
    display: grid;
    gap: 32px;

    @media (max-width: 768px) {
      gap: 16px;
    }
  }

  span {
    line-height: 19px;
  }

  .btn.btn--circle {
    margin-left: -25px;
    margin-top: -25px;
  }
  .btn {
    position: absolute;
    display: flex;
    z-index: 3;
    right: 5%;
    bottom: 10%;
    align-items: center;
    justify-content: center;
  }
  .btn--circle {
    border-radius: 100%;
    padding: 16px;
    width: auto;
    @media (max-width: 768px) {
      padding: 8px;
      width: 40px;
      height: 40px;
      right: 10%;
      bottom: 17%;
    }
  }
  .btn--default, .btn--icon {
    color: #e31519;
    background-color: #fff;
    display: inline-block;
  }

  .transform-flip-x {
    transform: scaleX(-1);
  }

  .icon-bold {
    font-size: 26px;
    font-weight: 1000;

    @media (max-width: 768px) {
      font-size: 20px;
    }
  }
}
</style>
  